import React from "react";
import { Grid, IconButton, Tooltip, Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';
import TextDecreaseIcon from '@mui/icons-material/TextDecrease';
import ContrastIcon from '@mui/icons-material/Contrast';

import { Wrapper } from "./header.styles";
import { useGlobalState } from "../../../global/context/global-context";
import { useAccessibility } from "../../../global/context/accessibility-context";

export function HeaderComponent() {
  const navigate = useNavigate();
  const { applicationData } = useGlobalState();
  const { increaseFontSize, decreaseFontSize, toggleHighContrast, highContrast } = useAccessibility();
  const cnpj = applicationData?.entity?.document || '';

  return (
    <Wrapper>
      <Container maxWidth="xl" disableGutters>
        <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        {/* Links da esquerda com controles de acessibilidade */}
        <Grid item xs>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs="auto">
              <Box
                onClick={() => navigate('/acessibilidade')}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8
                  }
                }}
              >
                <AccessibilityNewIcon fontSize="small" />
                <span>Acessibilidade</span>
              </Box>
            </Grid>

            {/* Accessibility Controls */}
            <Grid item xs="auto">
              <Box
                sx={{
                  display: 'flex',
                  gap: 0.5,
                  alignItems: 'center',
                  borderLeft: 1,
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                  pl: 2,
                }}
              >
                <Tooltip title="Diminuir fonte" arrow>
                  <IconButton
                    size="small"
                    onClick={decreaseFontSize}
                    sx={{
                      color: 'white',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      },
                    }}
                    aria-label="diminuir tamanho da fonte"
                  >
                    <TextDecreaseIcon fontSize="small" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Aumentar fonte" arrow>
                  <IconButton
                    size="small"
                    onClick={increaseFontSize}
                    sx={{
                      color: 'white',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      },
                    }}
                    aria-label="aumentar tamanho da fonte"
                  >
                    <TextIncreaseIcon fontSize="small" />
                  </IconButton>
                </Tooltip>

                <Tooltip title={highContrast ? "Desativar alto contraste" : "Ativar alto contraste"} arrow>
                  <IconButton
                    size="small"
                    onClick={toggleHighContrast}
                    sx={{
                      color: 'white',
                      backgroundColor: highContrast ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      },
                    }}
                    aria-label="alternar alto contraste"
                  >
                    <ContrastIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {/* Links da direita */}
        <Grid item xs="auto">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs="auto">
              <a
                href={`http://airdoc.com.br/ouvidoria?codEntidade=${cnpj}&empresa=3851`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                <RecordVoiceOverIcon fontSize="small" />
                <span>Ouvidoria</span>
              </a>
            </Grid>
            <Grid item xs="auto">
              <a
                href={`http://airdoc.com.br/sep?codEntidade=${cnpj}&empresa=3851`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                <CloudUploadIcon fontSize="small" />
                <span>Envio de Publicações</span>
              </a>
            </Grid>
            <Grid item xs="auto">
              <a
                href="http://scp.airdoc.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                <AssignmentIcon fontSize="small" />
                <span>SCP</span>
              </a>
            </Grid>
            <Grid item xs="auto">
              <a
                href={`http://airdoc.com.br/PortalMunicipio/Administrator?codEntidade=${cnpj}&empresa=3851`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                <AdminPanelSettingsIcon fontSize="small" />
                <span>Área Administrativa</span>
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      </Container>
    </Wrapper>
  );
}
